import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyFiltersCatalogState } from './filtersCatalog.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerFiltersCatalog = (state: AppState) =>
  state.taskTracker.filtersCatalog ?? createEmptyFiltersCatalogState()
